const enum Pages {
  ROOT = '/',
  NO_PERMISSIONS = 'wait',
  MY_ORGANIZATION = 'my-organization',
  PERSONAL_ACCOUNTS = 'personal-accounts',
  PAYMENT_HISTORY = 'payment-history',
  AUTH_CALLBACK = 'callback',
  NOT_AUTHORIZED = 'not-authorized',
  UNDISTRIBUTED_PAYMENTS = 'undistributed-payments',
  REPORTS = 'reports',
  LEDGER = 'ledger',
  DEBT_DYNAMICS = 'debt-dynamics',
  BALANCE_FINANCE = 'balanceFinance',

  // Організація (/my-organization): the same parts as the legacy pages of @gasbi/shared/web/Organization navigate to
  // (GSB-8317)
  EMPLOYEES = 'employees',
  SUBDIVISIONS = 'subdivisions',
  ROLES = 'roles',
  ORGANIZATIONS = 'organizations',
}

export default Pages;
